import type { ReactNode } from "react";

interface WindowProps {
  children: ReactNode;
  className?: string;
}

export default function Window({ children, className }: WindowProps) {
  return (
    <div className={`win-window${className ? ` ${className}` : ""}`}>
      {children}
    </div>
  );
}
